export const getSignInCallbackUrl = ({
  pathname,
  search,
}: {
  pathname: string;
  search: string;
}) => {
  const params = new URLSearchParams(search);
  return (
    params.get("redirect_url") ||
    (pathname.startsWith("/auth/signin") ? "/" : `${pathname}${search}`)
  );
};
